import { IGoogleConfig } from '../../types/google-interfaces';
import { addLoginQueryParams } from '../../utils/url';
import { appendUnityLoginIframe } from '../../utils/landing';
import { IGetSocialUserTokensRequest } from '../../domain-adapters/adapters/GetGoogleUserToken';

interface IGoogleTokens {
    access_token?: string
}

export class GoogleSignIn {
    private config: IGoogleConfig;

    constructor(config: IGoogleConfig) {
        this.config = config;
    }

    public init(): void {
        $('.gi').on('click', this.authenticateAndAuthorize.bind(this));
    }

    public async authenticate(): Promise<IGetSocialUserTokensRequest> {
        const credentials = await this.requestAuthentication();
        return credentials;
    }

    public signIn(credentials: IGoogleTokens): void {
        if (!credentials.access_token) {
            throw new Error('Google SignIn credentials is not found');
        }

        const oauthBaseUrl = window.app.config.google.oauth_url;
        const oAuthLink = `${oauthBaseUrl}?access_token=${credentials.access_token}`;
        const queriedLink = addLoginQueryParams(oAuthLink);
        appendUnityLoginIframe(queriedLink);
    }

    private async authenticateAndAuthorize(): Promise<void> {
        const credentials = await this.requestAuthentication();
        this.signIn(credentials);
    }

    private async requestAuthentication(): Promise<IGoogleTokens> {
        return new Promise((resolve, reject) => {
            try {
                const authentication = window.google.accounts.oauth2.initTokenClient({
                    callback: (credentials: IGoogleTokens) => resolve(credentials),
                    client_id: this.config.client_id,
                    scope: window.app.config.google.scope
                });
                authentication.requestAccessToken();
            } catch (exception) {
                reject(exception);
            }
        });
    }
}
